<template>
  <div id="navbar" class="navbar-collapse collapse">
    <ul class="nav navbar-nav navbar-right">
      <router-link
        class="btn btn-default navbar-btn mat"
        target="_blank"
        :to="{ name: 'HelpAndSupport' }"
      >
        Help & Support
      </router-link>
      <button @click="exitToolkit" class="btn btn-default navbar-btn mat">
        Exit Project
      </button>
    </ul>
  </div>
</template>

<script>
  export default {
    methods: {
      exitToolkit() {
        this.$router
          .push({ name: 'list-versions' })
          .then(() => this.$store.commit('SET_EDIT_MODE', false));
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@authoringPlatform/Navbar/baseNav.style.scss';

  .navbar-fixed-top {
    z-index: 0 !important;
  }
</style>
